export const buildTokenValueString = (tokenName, value) => ({
  type: "string",
  tokenName,
  value
});
export const buildTokenValueAmount = (tokenName, currency, amount, aggregationType = "none", aggregatedValuesIdentical) => ({
  type: "amount",
  tokenName,
  currency,
  amount,
  aggregationType,
  aggregatedValuesIdentical: aggregatedValuesIdentical ?? aggregatedValuesIdenticalDefaultValue
});
export const buildTokenValuePercentage = (tokenName, percentage) => ({
  type: "percentage",
  tokenName,
  percentage
});
export const buildTokenValueDate = (tokenName, date) => ({
  type: "date",
  tokenName,
  date
});
export const aggregatedValuesIdenticalDefaultValue = false;
//# sourceMappingURL=Tokens.js.map